var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskStart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90354 9.23694L7.12595 5.56972H8.70709L9.92949 9.23694L13.5967 10.4593V12.0405L9.92949 13.2629L8.70709 16.9301H7.12595L5.90354 13.2629L2.23633 12.0405V10.4593L5.90354 9.23694ZM7.91652 8.46847L7.35292 10.1593L6.82587 10.6863L5.13508 11.2499L6.82587 11.8135L7.35292 12.3406L7.91652 14.0313L8.48012 12.3406L9.00716 11.8135L10.698 11.2499L9.00716 10.6863L8.48012 10.1593L7.91652 8.46847Z",
    fill: "#5F6368"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4587 4.29213L14.1088 2.3418H15.0575L15.7076 4.29213L17.658 4.94224V5.89092L15.7076 6.54103L15.0575 8.49136H14.1088L13.4587 6.54103L11.5084 5.89092V4.94224L13.4587 4.29213Z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskStart);
export default __webpack_public_path__ + "static/media/taskStart.0350cdf33c81796f11e77cf26bfc5f9b.svg";
export { ForwardRef as ReactComponent };